export const MODULE_ID = 'integration';
export const STORAGE_PROVIDERS = {
    CentralStorage: 'CentralStorage',
    GoogleDrive: 'GoogleDrive'
};
